import styled from 'styled-components';

export const Wrapper = styled.div`
	align-items: center;
	display: flex;
	gap: 8px;
	padding-bottom: 16px;
	padding-right: 24px;

	@media (max-width: 992px) {
		padding-bottom: 8px;
		padding-right: 8px;
	}
`;
